import ContractsTasksList from './ContractsTasksList';

export default ContractsTasksList;
